export const calculateShiftTips = (state, shift) => {
  if (shift.Title === 'Server') {
    if (shift.SushiTip === 0) {
      const sushiTip = Number(
        (
          (shift.Sushi * (state.restaurant.SushiPercentage * 0.01)) /
          shift.ServerRatio
        ).toFixed(2),
      );
      const barTip = Number(
        (
          ((shift.Beer +
            shift.ByBottle +
            shift.Liquor +
            shift.MixedCocktails +
            shift.Sake +
            shift.Wine) *
            (state.restaurant.BarPercentage * 0.01)) /
          shift.ServerRatio
        ).toFixed(2),
      );
      const expoTip = Number(
        (
          ((shift.Food + shift.Sushi) *
            (state.restaurant.ExpoPercentage * 0.01)) /
          shift.ServerRatio
        ).toFixed(2),
      );
      const hostTip = Number(
        (
          ((shift.Beer +
            shift.ByBottle +
            shift.Liquor +
            shift.MixedCocktails +
            shift.Sake +
            shift.Wine +
            shift.Food +
            shift.Sushi +
            shift.NABeverage) *
            (state.restaurant.HostPercentage * 0.01)) /
          shift.ServerRatio
        ).toFixed(2),
      );
      const busserTip = Number(
        (
          ((shift.Beer +
            shift.ByBottle +
            shift.Liquor +
            shift.MixedCocktails +
            shift.Sake +
            shift.Wine +
            shift.Food +
            shift.Sushi +
            shift.NABeverage) *
            (state.restaurant.BusserPercentage * 0.01)) /
          shift.ServerRatio
        ).toFixed(2),
      );
      const ccTip = Number((shift.CCTip / shift.ServerRatio).toFixed(2));
      const ccTipFee = Number((shift.CCTipFee / shift.ServerRatio).toFixed(2));
      const NetSales = Number((shift.NetSales / shift.ServerRatio).toFixed(2));
      const finalTipOut = Number(
        (
          ccTip -
          sushiTip -
          barTip -
          expoTip -
          hostTip -
          busserTip -
          ccTipFee
        ).toFixed(2),
      );
      return {
        ...shift,
        NetSales,
        CCTip: ccTip,
        CCTipFee: ccTipFee,
        SushiTip: sushiTip,
        BarTip: barTip,
        ExpoTip: expoTip,
        HostTip: hostTip,
        BusserTip: busserTip,
        FinalTipOut: finalTipOut,
      };
    } else {
      const SushiTip = Number((shift.SushiTip / shift.ServerRatio).toFixed(2));
      const BarTip = Number((shift.BarTip / shift.ServerRatio).toFixed(2));
      const ExpoTip = Number(
        ((shift.ExpoTip * state.expoFactor) / shift.ServerRatio).toFixed(2),
      );
      const HostTip = Number(
        ((shift.HostTip * state.hostFactor) / shift.ServerRatio).toFixed(2),
      );
      const BusserTip = Number(
        ((shift.BusserTip * state.busserFactor) / shift.ServerRatio).toFixed(2),
      );
      const CCTip = Number((shift.CCTip / shift.ServerRatio).toFixed(2));
      const CCTipFee = Number((shift.CCTipFee / shift.ServerRatio).toFixed(2));
      const NetSales = Number((shift.NetSales / shift.ServerRatio).toFixed(2));
      const finalTipOut = Number(
        (
          CCTip -
          SushiTip -
          BarTip -
          ExpoTip -
          HostTip -
          BusserTip -
          CCTipFee
        ).toFixed(2),
      );
      return {
        ...shift,
        NetSales,
        CCTip,
        CCTipFee,
        SushiTip,
        BarTip,
        ExpoTip,
        HostTip,
        BusserTip,
        FinalTipOut: finalTipOut,
      };
    }
  } else if (shift.Title === 'Bartender') {
    if (shift.SushiTip === 0) {
      const sushiTip = Number(
        (
          shift.Sushi *
          (state.restaurant.SushiPercentage * 0.01) *
          shift.BarRatio
        ).toFixed(2),
      );
      const expoTip = Number(
        (
          (shift.Food + shift.Sushi) *
          (state.restaurant.ExpoPercentage * 0.01) *
          shift.BarRatio
        ).toFixed(2),
      );
      const hostTip = Number(
        (
          (shift.Beer +
            shift.ByBottle +
            shift.Liquor +
            shift.MixedCocktails +
            shift.Sake +
            shift.Wine +
            shift.Food +
            shift.Sushi +
            shift.NABeverage) *
          (state.restaurant.HostPercentage * 0.01) *
          shift.BarRatio
        ).toFixed(2),
      );
      const busserTip = Number(
        (
          (shift.Beer +
            shift.ByBottle +
            shift.Liquor +
            shift.MixedCocktails +
            shift.Sake +
            shift.Wine +
            shift.Food +
            shift.Sushi +
            shift.NABeverage) *
          (state.restaurant.BusserPercentage * 0.01) *
          shift.BarRatio
        ).toFixed(2),
      );
      const finalTipOut = Number(
        (
          shift.CCTip * shift.BarRatio +
          state.totalBarTips * shift.BarRatio -
          sushiTip -
          expoTip -
          hostTip -
          busserTip -
          shift.CCTipFee * shift.BarRatio
        ).toFixed(2),
      );
      return {
        ...shift,
        SushiTip: sushiTip,
        BarTip: 0,
        ExpoTip: expoTip,
        HostTip: hostTip,
        BusserTip: busserTip,
        FinalTipOut: finalTipOut,
      };
    } else {
      if (shift.FinalTipOut === 0 || shift.BarRatio === 1) {
        const SushiTip = Number((shift.SushiTip * shift.BarRatio).toFixed(2));
        const ExpoTip = Number(
          (shift.ExpoTip * shift.BarRatio * state.expoFactor).toFixed(2),
        );
        const HostTip = Number(
          (shift.HostTip * shift.BarRatio * state.hostFactor).toFixed(2),
        );
        const BusserTip = Number(
          (shift.BusserTip * shift.BarRatio * state.busserFactor).toFixed(2),
        );
        const finalTipOut = Number(
          (
            shift.CCTip * shift.BarRatio +
            state.totalBarTips * shift.BarRatio -
            SushiTip -
            ExpoTip -
            HostTip -
            BusserTip -
            shift.CCTipFee * shift.BarRatio
          ).toFixed(2),
        );
        return {
          ...shift,
          SushiTip,
          ExpoTip,
          HostTip,
          BusserTip,
          FinalTipOut: finalTipOut,
        };
      } else {
        window.alert(
          "In order to recalculate bartender's tipout, you have to reset the final tipout to 0 and input the original numbers again.",
        );
        return shift;
      }
    }
  } else if (shift.EmployeeID === 1) {
    const finalTipOut = Number((shift.CCTip - shift.CCTipFee).toFixed(2));
    return {
      ...shift,
      FinalTipOut: finalTipOut,
    };
  } else if (shift.Title === 'Host') {
    const numOfHost = state.shifts.filter(
      (i) => i.Title === 'Host' && i.IsLunch === false,
    ).length;
    const numOfExpo = state.shifts.filter(
      (i) => i.Title === 'Expo' && i.IsLunch === false,
    ).length;
    const numOfDailyHost = state.shifts.filter(
      (i) => i.Title === 'Host',
    ).length;
    const allDayHostTips = state.totalLunchHostTips + state.totalHostTips;
    if (state.restaurant.ID === 2) {
      if (shift.HostRatio === 1) {
        const finalTipOut = Number(
          (
            allDayHostTips / numOfDailyHost +
            state.totalToGoTips / (numOfHost + numOfExpo)
          ).toFixed(2),
        );
        return {
          ...shift,
          FinalTipOut: finalTipOut,
        };
      } else {
        const finalTipOut = Number(
          (
            allDayHostTips * shift.HostRatio +
            state.totalToGoTips / (numOfHost + numOfExpo)
          ).toFixed(2),
        );
        return {
          ...shift,
          FinalTipOut: finalTipOut,
        };
      }
    } else if (state.restaurant.ID === 1 || state.restaurant.ID === 3) {
      if (shift.HostRatio === 1) {
        const finalTipOut = Number(
          (allDayHostTips / numOfDailyHost).toFixed(2),
        );
        return {
          ...shift,
          FinalTipOut: finalTipOut,
        };
      } else {
        const finalTipOut = Number(
          (allDayHostTips * shift.HostRatio).toFixed(2),
        );
        return {
          ...shift,
          FinalTipOut: finalTipOut,
        };
      }
    }
  } else if (shift.Title === 'Expo') {
    const numOfHost = state.shifts.filter(
      (i) => i.Title === 'Host' && i.IsLunch === false,
    ).length;
    const numOfExpo = state.shifts.filter(
      (i) => i.Title === 'Expo' && i.IsLunch === false,
    ).length;
    if (state.restaurant.ID === 2) {
      if (shift.ExpoRatio === 1) {
        const finalTipOut = Number(
          (
            state.totalExpoTips / numOfExpo +
            state.totalToGoTips / (numOfHost + numOfExpo)
          ).toFixed(2),
        );
        return {
          ...shift,
          FinalTipOut: finalTipOut,
        };
      } else {
        const finalTipOut = Number(
          (
            state.totalExpoTips * shift.ExpoRatio +
            state.totalToGoTips / (numOfHost + numOfExpo)
          ).toFixed(2),
        );
        return {
          ...shift,
          FinalTipOut: finalTipOut,
        };
      }
    } else if (state.restaurant.ID === 1 || state.restaurant.ID === 3) {
      if (shift.ExpoRatio === 1) {
        const finalTipOut = Number(
          (
            state.totalExpoTips / numOfExpo +
            state.totalToGoTips / numOfExpo
          ).toFixed(2),
        );
        return {
          ...shift,
          FinalTipOut: finalTipOut,
        };
      } else {
        const finalTipOut = Number(
          (
            state.totalExpoTips * shift.ExpoRatio +
            state.totalToGoTips * shift.ExpoRatio
          ).toFixed(2),
        );
        return {
          ...shift,
          FinalTipOut: finalTipOut,
        };
      }
    }
  } else if (shift.Title === 'Busser') {
    const numOfBusser = state.shifts.filter(
      (i) => i.Title === 'Busser' && i.IsLunch === false,
    ).length;
    if (shift.BusserRatio === 1) {
      const finalTipOut = Number(
        (state.totalBusserTips / numOfBusser).toFixed(2),
      );
      return {
        ...shift,
        FinalTipOut: finalTipOut,
      };
    } else {
      const finalTipOut = Number(
        (state.totalBusserTips * shift.BusserRatio).toFixed(2),
      );
      return {
        ...shift,
        FinalTipOut: finalTipOut,
      };
    }
  }
  return shift;
};

export const calculateSplittedDinnerServerTips = (shifts) => {
  let totalNetSales = 0;
  let totalSushiTips = 0;
  let totalExpoTips = 0;
  let totalHostTips = 0;
  let totalBusserTips = 0;
  let totalCCTips = 0;
  let count = 0;
  for (let i = 0; i < shifts.length; i++) {
    if (
      shifts[i].IsLunch === false &&
      (shifts[i].Title === 'Server' || shifts[i].Title === 'Bartender')
    ) {
      if (shifts[i].Title === 'Bartender') {
        totalNetSales = totalNetSales + shifts[i].NetSales * shifts[i].BarRatio;
        totalCCTips = totalCCTips + shifts[i].CCTip * shifts[i].BarRatio;
      } else {
        totalNetSales = totalNetSales + shifts[i].NetSales;
        totalCCTips = totalCCTips + shifts[i].CCTip;
      }
      totalSushiTips = totalSushiTips + shifts[i].SushiTip;
      totalHostTips = totalHostTips + shifts[i].HostTip;
      totalExpoTips = totalExpoTips + shifts[i].ExpoTip;
      totalBusserTips = totalBusserTips + shifts[i].BusserTip;
      count++;
    }
  }

  const splittedNetSales = Number((totalNetSales / count).toFixed(2));
  const splittedSushiTip = Number((totalSushiTips / count).toFixed(2));
  const splittedHostTip = Number((totalHostTips / count).toFixed(2));
  const splittedExpoTip = Number((totalExpoTips / count).toFixed(2));
  const splittedBusserTip = Number((totalBusserTips / count).toFixed(2));
  const splittedCCTip = Number((totalCCTips / count).toFixed(2));
  //const splittedCCTipFee = Number((splittedCCTip * 0.025).toFixed(2));
  const splittedCCTipFee = 0;
  const splittedFinalTipOut = Number(
    (
      splittedCCTip -
      splittedCCTipFee -
      splittedSushiTip -
      splittedHostTip -
      splittedBusserTip -
      splittedExpoTip
    ).toFixed(2),
  );
  return shifts.map((item) => {
    if (item.IsLunch === false && item.Title === 'Server') {
      return {
        ...item,
        NetSales: splittedNetSales,
        SushiTip: splittedSushiTip,
        HostTip: splittedHostTip,
        ExpoTip: splittedExpoTip,
        BusserTip: splittedBusserTip,
        CCTip: splittedCCTip,
        CCTipFee: splittedCCTipFee,
        FinalTipOut: splittedFinalTipOut,
      };
    } else if (item.IsLunch === false && item.Title === 'Bartender') {
      return {
        ...item,
        NetSales: splittedNetSales,
        SushiTip: splittedSushiTip,
        HostTip: splittedHostTip,
        ExpoTip: splittedExpoTip,
        BusserTip: splittedBusserTip,
        BarRatio: 1,
        CCTip: splittedCCTip,
        CCTipFee: splittedCCTipFee,
        FinalTipOut: splittedFinalTipOut,
      };
    }
    return item;
  });
};

export const calculateTotalBarTips = (shifts) =>
  shifts.reduce((pre, current) => {
    if (
      !current.IsLunch &&
      current.BarTip !== undefined &&
      current.BarTip !== 0
    ) {
      return pre + current.BarTip;
    } else {
      return pre;
    }
  }, 0);

export const calculateTotalSushiTips = (shifts) =>
  shifts.reduce((pre, current) => {
    if (
      !current.IsLunch &&
      current.SushiTip !== undefined &&
      current.SushiTip !== 0
    ) {
      return pre + current.SushiTip;
    } else {
      return pre;
    }
  }, 0);

export const calculateTotalHostTips = (shifts) =>
  shifts.reduce((pre, current) => {
    if (
      !current.IsLunch &&
      current.HostTip !== undefined &&
      current.HostTip !== 0
    ) {
      return pre + current.HostTip;
    } else {
      return pre;
    }
  }, 0);

export const calculateTotalExpoTips = (shifts) =>
  shifts.reduce((pre, current) => {
    if (
      !current.IsLunch &&
      current.ExpoTip !== undefined &&
      current.ExpoTip !== 0
    ) {
      return pre + current.ExpoTip;
    } else {
      return pre;
    }
  }, 0);

export const calculateTotalBusserTips = (shifts) =>
  shifts.reduce((pre, current) => {
    if (
      !current.IsLunch &&
      current.BusserTip !== undefined &&
      current.BusserTip !== 0
    ) {
      return pre + current.BusserTip;
    } else {
      return pre;
    }
  }, 0);

export const calculateTotalToGoTips = (shifts) => {
  const togo = shifts.filter((i) => i.EmployeeID === 1 && i.IsLunch === false);
  if (togo.length === 0) return 0;
  else return togo[0].FinalTipOut;
};

export const calculateTotalDinnerTipOut = (shifts) => {
  const dinnerShifts = shifts.filter(
    (i) => i.IsLunch === false && i.EmployeeID !== 1,
  );
  if (dinnerShifts.length === 0) return 0;
  else {
    const shiftsTipOut = dinnerShifts.reduce((pre, current) => {
      return pre + current.FinalTipOut;
    }, 0);
    const sushiTipOut = dinnerShifts.reduce((pre, current) => {
      if (current.SushiTip !== undefined && current.SushiTip !== 0) {
        return pre + current.SushiTip;
      } else {
        return pre;
      }
    }, 0);
    return shiftsTipOut + sushiTipOut;
  }
};

export const calculateDinnerTipPool = (shifts) =>
  shifts
    .filter((i) => i.IsLunch === false)
    .reduce((pre, current) => {
      if (current.Title === 'Server' || current.EmployeeID === 1) {
        return pre + current.CCTip;
      } else if (current.Title === 'Bartender') {
        return pre + current.CCTip * current.BarRatio;
      }
      return pre;
    }, 0);

export const validateDinnerTipPool = (state) => {
  // Validting all the tip out are calculated
  const dinnerShifts = state.shifts.filter((i) => i.IsLunch === false);
  // if (dinnerShifts.filter(i =>i.FinalTipOut === 0 || i.FinalTipOut === undefined).length > 0) {
  //   alert("Some shifts' tip out are not calculated!")
  //   return
  // }
  // Validating bar tips assigned
  const barShifts = state.shifts.filter(
    (i) => i.Title === 'Bartender' && i.IsLunch === false,
  );
  const calculatedTotalBarTip = Number(
    barShifts
      .reduce((pre, current) => {
        return pre + current.FinalTipOut;
      }, 0)
      .toFixed(2),
  );
  let barshiftTotalTips = 0;
  barShifts.forEach((i) => {
    const shiftTip = Number(
      (
        i.CCTip * i.BarRatio -
        i.SushiTip -
        i.ExpoTip -
        i.HostTip -
        i.BusserTip -
        i.CCTipFee * i.BarRatio
      ).toFixed(2),
    );
    barshiftTotalTips = barshiftTotalTips + shiftTip;
  });
  const barTipPool = Number(
    (calculatedTotalBarTip - barshiftTotalTips).toFixed(2),
  );

  // Validating host tips assigned
  const hostShifts = state.shifts.filter(
    (i) => i.Title === 'Host' /*&& i.IsLunch === false*/,
  );
  const expoShifts = state.shifts.filter(
    (i) => i.Title === 'Expo' && i.IsLunch === false,
  );
  const busserShifts = state.shifts.filter(
    (i) => i.Title === 'Busser' && i.IsLunch === false,
  );
  if (hostShifts.length === 0 || busserShifts.length === 0) {
    alert('Could not perform tip pool validation');
    return;
  }
  const calculatedTotalHostTip = Number(
    hostShifts
      .reduce((pre, current) => {
        return pre + current.FinalTipOut;
      }, 0)
      .toFixed(2),
  );
  const calculatedTotalExpoTip = Number(
    expoShifts
      .reduce((pre, current) => {
        return pre + current.FinalTipOut;
      }, 0)
      .toFixed(2),
  );
  const calculatedTotalBusserTip = Number(
    busserShifts
      .reduce((pre, current) => {
        return pre + current.FinalTipOut;
      }, 0)
      .toFixed(2),
  );

  const hostExpoTipPool = Number(
    (state.totalHostTips + state.totalExpoTips + state.totalToGoTips).toFixed(
      2,
    ),
  );
  const hostExpoTipOut = Number(
    (calculatedTotalHostTip + calculatedTotalExpoTip).toFixed(2),
  );

  // Validating total tip out
  const calculatedTotalSushiTipOut = Number(
    dinnerShifts
      .reduce((pre, current) => {
        return pre + current.SushiTip;
      }, 0)
      .toFixed(2),
  );
  const calculatedTotalTipOut = Number(
    dinnerShifts
      .reduce((pre, current) => {
        return pre + current.FinalTipOut;
      }, 0)
      .toFixed(2),
  );

  const totalDinnerTipPool = Number(
    (state.totalDinnerTipOut - calculatedTotalSushiTipOut).toFixed(2),
  );

  if (state.totalBarTips - barTipPool > 0.02) {
    alert(
      "Total bar tip out doesn't match! Total bar tip pool: " +
        state.totalBarTips +
        '; Total Host and Expo Tip Out: ' +
        barTipPool,
    );
  } else if (hostExpoTipPool - hostExpoTipOut > 0.02) {
    alert(
      "Total host and expo tip out doesn't match! Total host and expo tip pool: " +
        hostExpoTipPool +
        '; Total Host and Expo Tip Out: ' +
        hostExpoTipOut,
    );
  } else if (state.totalBusserTips - calculatedTotalBusserTip > 0.02) {
    alert(
      "Total busser tip out doesn't match! Total busser tip pool: " +
        state.totalBusserTips +
        '; Total Host Tip Out: ' +
        calculatedTotalBusserTip,
    );
  } else if (totalDinnerTipPool - calculatedTotalTipOut > 0.02) {
    alert(
      "Total tip out doesn't match! Total tip out pool: " +
        totalDinnerTipPool +
        '; Total Tip Out: ' +
        calculatedTotalTipOut,
    );
  } else {
    alert('Validation passed!');
  }
};
